import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ProductAccessDeniedProps {
  symbol: string;
}

export const ProductAccessDenied = ({ symbol }: ProductAccessDeniedProps) => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="column" flex={1} padding={2} gap={2} height="100%">
      <Paper>
        <Box display="flex" flexDirection="column" alignItems="center" padding={4} gap={2}>
          <Typography variant="h4" color="error">
            Access Denied
          </Typography>
          <Typography variant="h6" color="text.secondary">
            You don't have access to product: {symbol}
          </Typography>
          <Typography variant="body1" color="text.secondary" textAlign="center">
            This product is not available in your user products list. Please contact <a href="mailto:support@flux.live">support@flux.live</a> if you
            believe this is an error.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/reference/products')} sx={{ marginTop: 2 }}>
            Back to Products
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
